/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Groupfilteraspect3Inputs */



/**

* @param {_Class_Groupfilteraspect3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_groupfilteraspect3 = /** @type {((inputs?: _Class_Groupfilteraspect3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Groupfilteraspect3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("ist")
});
export { _class_groupfilteraspect3 as "_class_GroupFilterAspect" }